import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UIAppProperties } from '@claim-tracker/common/models-ts';
import { Observable, tap } from 'rxjs';

/**
 * Service for getting app properties.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable({
	providedIn: 'root'
})
export class AppPropertiesService {
	private readonly appPropertiesUrl = '/appProperties';

	appProperties: UIAppProperties;

	/**
	 * @param http the Angular Http Client
	 */
	constructor(private http: HttpClient) {}

	/**
	 * Fetch the application properties.
	 */
	fetchAppProperties = (): Observable<UIAppProperties> =>
		this.http
			.get<UIAppProperties>(this.appPropertiesUrl)
			.pipe(tap(properties => (this.appProperties = properties)));
}
